import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';

import BreakList from '../UI/BreakList';
import TrayTable from '../UI/TrayTable';
import SlipSlider from '../UI/SlipSlider';
import OddsBall from '../UI/OddsBall';

const matterForm = (props) => {

	if(!props.measures) return null;

	let fieldset = Object.keys(props.fields)
		.map(field => {

			const m = props.fields[field];
			const data = props.measures[m.code];
			if(data === undefined)
				return null;

			const counter_field = m.name.indexOf('Counter') >= 0 ? true : false;
			if(counter_field && !props.matter.has_counter)
				return null;

			let halflocked = false;

			let controller = null;
			switch(m.type) {
				case 'breaklist': 	controller = <BreakList field={field} id={m.code} data={data} mode={m.mode} />; 	break;
				case 'traytable': 	controller = <TrayTable field={field} id={m.code} data={data} />; 	break;
				case 'slipslider': 	controller = <SlipSlider field={field} id={m.code} data={data} angle={props.matter.angle} halflock={halflocked} />; 	break;
				case 'oddsball': 	controller = <OddsBall field={field} id={m.code} data={data} />; 	break;
				default: 			controller = null; 								break;
			}

			if(!controller)
				return null;

			return (
				<div className='field' key={field}>
					<h3>{m.name}<span className='field__help' onClick={() => props.rdxSetModal('help_' + m.code)}
						><span className='field__help__text'>Information </span><i className='fas fa-question-circle'></i></span></h3>
					{controller}
				</div>
			);
		});

	let classes = 'matter-form';
	if(props.size === 'small')
		classes += ' matter-form--small';

	return (
		<div className={classes}>
			{fieldset}
		</div>
	);

}


const mapStateToProps = state => {
	return {
		matter: state.matter,
		fields: state.fields,
		measures: state.measures
	};
}

const mapDispatchToProps = dispatch => {
	return {
		rdxSetModal: (content) => dispatch(actions.setModal(content))
	};
}


export default connect(mapStateToProps,mapDispatchToProps)(matterForm);


// WEBPACK FOOTER //
// ./src/Blocks/MatterForm.js